import { createSlice } from '@reduxjs/toolkit';
import { Contract } from 'modules/types/Contract';
import { fetchSearchResults } from './thunks';
import { LeasingOffer } from '../../../types/LeasingOffer';
import { Bill } from '../../../types/Bill';

export interface SearchState {
  loading: boolean;
  error?: string;
  searchResults?: {
    contractsResults?: Contract[];
    billsResults?: Bill[];
    offersResults?: LeasingOffer[];
  };
}

const initialState: SearchState = {
  searchResults: undefined,
  loading: true,
  error: undefined,
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    resetState: (state) => {
      state.searchResults = initialState.searchResults;
      state.loading = initialState.loading;
      state.error = initialState.error;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSearchResults.pending, (state, action) => {
      state.loading = initialState.loading;
      state.error = initialState.error;
      state.searchResults = initialState.searchResults;
    });
    builder.addCase(fetchSearchResults.fulfilled, (state, action) => {
      state.searchResults = {
        contractsResults: action.payload.contractsResults,
        billsResults: action.payload.billsResults,
        offersResults: action.payload.offersResults,
      };
      state.loading = false;
    });
    builder.addCase(fetchSearchResults.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload
        ? (action.payload as Error)?.message
        : action.error?.message;
    });
  },
});

export const { resetState } = searchSlice.actions;

export default searchSlice.reducer;
